import { SignOut } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

export function Logout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('@tlp-authToken');
    
    navigate('/login');
  };
  
  return (
    <Button 
      variant="outline" 
      size="icon"
      onClick={handleLogout}
      className="hover:bg-gray-100 text-gray-300 dark:text-gray-100"
    >
      <SignOut 
        className="h-5 w-5" 
        weight="bold"
      />
    </Button>
  );
}